import { useNavigate } from "react-router-dom";
import { Alert, Box, Button, Typography } from "@mui/material";
import { AuthState } from "context/AuthContext";
import { admin, rootProtectedPath } from "data/authData";
import WHAllocation from "./WHAllocation";

/**
 * Renders WHAllocation only if the user has AXIS service-level access (role.AXIS or admin).
 * Otherwise shows Access Denied.
 */
const AxisRouteGuard = () => {
	const navigate = useNavigate();
	const { user } = AuthState();

	const hasAxisAccess = () => user?.role?.[admin] || user?.role?.AXIS;

	if (!user) return null;

	if (!hasAxisAccess()) {
		return (
			<Box sx={{ p: 3, maxWidth: 480 }}>
				<Alert severity="error">
					<Typography variant="subtitle1" gutterBottom>
						Access denied
					</Typography>
					<Typography variant="body2" color="text.secondary">
						You do not have access to AXIS. Contact your Engineering team to get AXIS access.
					</Typography>
					<Button variant="outlined" size="small" sx={{ mt: 2 }} onClick={() => navigate(`/${rootProtectedPath}`)}>
						Back to Explore
					</Button>
				</Alert>
			</Box>
		);
	}

	return <WHAllocation />;
};

export default AxisRouteGuard;
